import React, { useState, useEffect } from "react";
import "../styles/Footer.css";
import logo from "../assets/images/sacs-logo.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const [showButton, setShowButton] =
    useState(false);

  /* =========================================================
     SHOW BACK TO TOP BUTTON
  ========================================================= */

  useEffect(() => {
    const handleScroll = () => {
      setShowButton(window.scrollY > 200);
    };

    window.addEventListener(
      "scroll",
      handleScroll
    );

    return () =>
      window.removeEventListener(
        "scroll",
        handleScroll
      );
  }, []);

  /* =========================================================
     SCROLL TO TOP
  ========================================================= */

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  return (
    <footer
      className="footer"
      role="contentinfo"
    >
      <div className="footer-container">

        {/* =====================================================
           BRANDING
        ===================================================== */}

        <div className="footer-brand">

          <a
            href="/"
            className="footer-logo-link"
            aria-label="SACS Home"
          >
            <img
              src={logo}
              alt="SACS Logo"
              className="footer-logo"
            />
          </a>

          <h2>SACS</h2>

          <p>
            Sri Ayyappa Catering Service
          </p>

        </div>

        {/* =====================================================
           QUICK LINKS
        ===================================================== */}

        <div className="footer-section">

          <h4>Quick Links</h4>

          <nav aria-label="Footer Navigation">

            <ul>

              <li>
                <a href="/">
                  Home
                </a>
              </li>

              <li>
                <a href="/catering">
                  Catering
                </a>
              </li>

              <li>
                <a href="/chef-booking">
                  Chef Booking
                </a>
              </li>

              <li>
                <a href="/cloud-kitchen">
                  Daily Foods
                </a>
              </li>

              <li>
                <a href="/contact">
                  Contact
                </a>
              </li>

            </ul>

          </nav>

        </div>

        {/* =====================================================
           CONTACT INFO
        ===================================================== */}

        <div className="footer-section">

          <h4>Contact</h4>

          <address className="footer-contact">

            <div className="footer-contact-item">

              <span className="footer-contact-icon">
                📍
              </span>

              <span>
                Chennai, Tamil Nadu
              </span>

            </div>

            <div className="footer-contact-item">

              <span className="footer-contact-icon">
                📞
              </span>

              <a href="tel:+918939216516">
                +91 89392 16516
              </a>

            </div>

            <div className="footer-contact-item">

              <span className="footer-contact-icon">
                📞
              </span>

              <a href="tel:+917550014306">
                +91 75500 14306
              </a>

            </div>

            <div className="footer-contact-item">

              <span className="footer-contact-icon">
                ✉
              </span>

              <a href="mailto:sacs-info@zohomail.in">
                sacs-info@zohomail.in
              </a>

            </div>

          </address>

        </div>

        {/* =====================================================
           WHATSAPP SUPPORT
        ===================================================== */}

        <div className="footer-section">

          <h4>Order Support</h4>

          <div className="social-icons">

            <a
              href="https://wa.me/919585946095"
              aria-label="WhatsApp Business Chat"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon whatsapp"
            >

              <span className="whatsapp-icon">
                💬
              </span>

              <span className="whatsapp-text">
                WhatsApp Orders & Queries
              </span>

            </a>

          </div>

        </div>

      </div>

      {/* =====================================================
         FOOTER BOTTOM
      ===================================================== */}

      <div className="footer-bottom">

        <p>
          © {currentYear} SACS • Serving
          Since 2000 • All Rights Reserved.
        </p>

      </div>

      {/* =====================================================
         BACK TO TOP BUTTON
      ===================================================== */}

      {showButton && (

        <button
          className="back-to-top"
          onClick={scrollToTop}
          aria-label="Back to Top"
        >
          ⬆
        </button>

      )}

    </footer>
  );
};

export default Footer;